module.exports = __webpack_public_path__ + "static/img/台灣真美.2ac36ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/台灣真美.png?20181011
// module id = UUTP
// module chunks = 1